import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * Primitive TextField component
 * Styled version of MUI TextField that respects the theme
 */
const TextField = ({ ...props }) => {
  const theme = useTheme();

  return (
    <MuiTextField
      {...props}
      sx={{
        ...props.sx,
      }}
    />
  );
};

export default TextField;

